import { createFileRoute } from '@tanstack/react-router'
import { Receipt } from 'lucide-react'
import { InvoiceScreen } from '@/screens/billing/SCR-163-164-invoices'

export const Route = createFileRoute('/_app/billing/invoices_/$invoiceId')({
  staticData: { screen: { id: 'SCR-164', title: 'Invoice', group: 'Organisation', perm: ['billing.read', 'billing.manage'], hidden: true, description: 'Seller, buyer, lines, GST and payment for one invoice.', icon: Receipt } },
  component: function InvoiceRoute() {
    const { invoiceId } = Route.useParams()
    return <InvoiceScreen invoiceId={invoiceId} />
  },
})
